/**
 * Colorblind-friendly palette
 * Based on recommendations for accessible color design
 */
export const TILE_COLORS = {
  0: 0x4285f4, // Blue
  1: 0xff9800, // Orange
  2: 0x4caf50, // Green
  3: 0x9c27b0, // Purple
  4: 0xffeb3b, // Yellow
};

export const BG_COLOR = 0x1a1a1a; // Dark background
export const GRID_BORDER_COLOR = 0x333333; // Grid border
export const HIGHLIGHT_COLOR = 0xffffff; // White highlight for hover
